var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 55,
    viewBox: "0 0 218 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1363 22.4374C35.2729 23.6709 36.0043 26.4026 34.7708 28.5392L21.17 52.5422C19.9365 54.6788 17.2048 55.4103 15.0682 54.1768C12.9316 52.9432 12.2002 50.2115 13.4337 48.0749L27.0345 24.0719C28.268 21.9353 30.9997 21.2039 33.1363 22.4374Z",
    fill: "url(#paint0_linear_214_10556)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49892 24.8142C9.49892 22.3471 11.4992 20.3469 13.9662 20.3469H43.6604C45.2484 20.3469 46.7177 21.1906 47.5181 22.5637C49.2553 25.5408 47.1075 29.2814 43.6604 29.2814H13.9662C11.4992 29.2814 9.49892 27.2812 9.49892 24.8142Z",
    fill: "url(#paint1_linear_214_10556)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2377 0C26.7121 0 28.8727 3.77433 27.1147 6.7707L8.38579 37.2926C6.64539 40.2569 2.35776 40.2505 0.626991 37.2814L0.612555 37.2573C-0.207115 35.8522 -0.203909 34.115 0.620574 32.713L19.3623 2.21519C20.1707 0.842126 21.6449 0 23.2377 0Z",
    fill: "url(#paint2_linear_214_10556)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6027 0.0140582C47.0161 0.0349109 49.1479 3.71621 47.4701 6.68691L42.3339 15.7771C41.5222 17.2143 39.984 18.0885 38.3334 18.0484L38.1682 18.0452C34.7644 17.9634 32.6951 14.2612 34.4115 11.3194L39.7113 2.23246C40.5181 0.851371 42.0019 0.0044339 43.6027 0.0140582Z",
    fill: "url(#paint3_linear_214_10556)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.92 15.8436V34.4314C79.92 35.5735 79.0314 36.4621 77.9214 36.4621C76.8114 36.4621 75.8907 35.5735 75.8907 34.4314V27.4217H60.126V34.4314C60.126 35.5735 59.2374 36.4621 58.1274 36.4621C57.0174 36.4621 56.0967 35.5735 56.0967 34.4314V15.8436C56.0967 14.7336 57.0158 13.8129 58.1274 13.8129C59.2374 13.8129 60.126 14.7336 60.126 15.8436V23.3923H75.8907V15.8436C75.8907 14.7336 76.8114 13.8129 77.9214 13.8129C79.0314 13.8129 79.92 14.732 79.92 15.8436Z",
    fill: "#303030"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.182 15.8435C108.182 16.9535 107.263 17.8421 106.151 17.8421H86.3571C85.2471 17.8421 84.3584 16.9535 84.3584 15.8435C84.3584 14.7335 85.2471 13.8127 86.3571 13.8127H106.151C107.263 13.8127 108.182 14.7319 108.182 15.8435ZM108.182 25.1373C108.182 26.2473 107.263 27.1681 106.151 27.1681H86.3571C85.2471 27.1681 84.3584 26.2473 84.3584 25.1373C84.3584 24.0273 85.2471 23.1387 86.3571 23.1387H106.151C107.263 23.1387 108.182 24.0257 108.182 25.1373ZM108.182 34.4312C108.182 35.5733 107.263 36.462 106.151 36.462H86.3571C85.2471 36.462 84.3584 35.5733 84.3584 34.4312C84.3584 33.3212 85.2471 32.4326 86.3571 32.4326H106.151C107.263 32.4326 108.182 33.3212 108.182 34.4312Z",
    fill: "#303030"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.384 25.1373C115.384 29.6415 118.587 32.4326 123.695 32.4326H125.281C127.913 32.4326 130.071 31.7027 131.53 30.3072C132.355 29.5453 133.624 29.5453 134.386 30.3714C135.148 31.1638 135.148 32.4326 134.321 33.2266C132.101 35.352 128.993 36.462 125.281 36.462H123.695C119.952 36.462 116.812 35.3199 114.592 33.1624C113.544 32.1471 112.72 30.9103 112.181 29.5148C111.642 28.1514 111.356 26.6917 111.356 25.1373C111.356 23.6151 111.642 22.1233 112.181 20.792C112.72 19.3964 113.544 18.1597 114.592 17.1123C116.812 14.9548 119.952 13.8127 123.695 13.8127H125.281C129.023 13.8127 132.164 14.9548 134.384 17.1123C135.176 17.9047 135.176 19.1735 134.416 19.9675C133.654 20.7599 132.355 20.792 131.561 19.9996C130.101 18.604 127.945 17.8421 125.279 17.8421H123.693C118.587 17.8405 115.384 20.6636 115.384 25.1373Z",
    fill: "#303030"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161.029 15.8434C161.029 16.9534 160.14 17.8421 159.03 17.8421H151.132V34.4312C151.132 35.5733 150.243 36.4619 149.133 36.4619C148.023 36.4619 147.103 35.5733 147.103 34.4312V17.8405H139.236C138.126 17.8405 137.206 16.9518 137.206 15.8418C137.206 14.7318 138.126 13.8111 139.236 13.8111H159.03C160.142 13.8127 161.029 14.7318 161.029 15.8434Z",
    fill: "#303030"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.056 20.792C188.594 22.1249 188.88 23.6151 188.88 25.1373C188.88 26.6917 188.594 28.1514 188.056 29.5148C187.517 30.9103 186.692 32.1471 185.645 33.1624C183.425 35.3199 180.284 36.462 176.542 36.462H174.955C171.213 36.462 168.072 35.3199 165.852 33.1624C164.805 32.1471 163.98 30.9103 163.409 29.5148C162.902 28.1514 162.617 26.6917 162.617 25.1373C162.617 23.6151 162.902 22.1233 163.409 20.792C163.98 19.3964 164.805 18.1597 165.852 17.1123C168.072 14.9548 171.213 13.8127 174.955 13.8127H176.542C180.284 13.8127 183.425 14.9548 185.645 17.1123C186.692 18.1581 187.517 19.3948 188.056 20.792ZM184.852 25.1373C184.852 20.6652 181.649 17.8421 176.542 17.8421H174.955C169.816 17.8421 166.645 20.6652 166.645 25.1373C166.645 29.6415 169.817 32.4326 174.955 32.4326H176.542C181.647 32.4326 184.852 29.6415 184.852 25.1373Z",
    fill: "#303030"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218 34.4317C218 35.5738 217.081 36.4624 215.969 36.4624H212.734C212.163 36.4624 211.624 36.2411 211.242 35.8288L205.089 29.1672H196.398V34.4333C196.398 35.5754 195.478 36.464 194.368 36.464C193.258 36.464 192.369 35.5754 192.369 34.4333V27.1381C192.369 26.0281 193.258 25.1073 194.368 25.1073H208.515C210.514 25.1073 212.163 23.4905 212.163 21.4918C212.163 19.4932 210.514 17.8442 208.515 17.8442H194.368C193.258 17.8442 192.369 16.9556 192.369 15.8455C192.369 14.7355 193.258 13.8148 194.368 13.8148H208.515C210.576 13.8148 212.48 14.6393 213.94 16.0669C215.4 17.5266 216.192 19.429 216.192 21.4918C216.192 23.5546 215.4 25.457 213.94 26.9167C212.957 27.9 211.72 28.5978 210.387 28.9154L213.623 32.4362H215.969C217.079 32.433 218 33.3217 218 34.4317Z",
    fill: "#303030"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_10556",
    x1: 6.51852,
    y1: 8.09514,
    x2: 32.815,
    y2: 53.2757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.75506e-7,
    stopColor: "#FF0078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0636,
    stopColor: "#E80089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1972,
    stopColor: "#AD00B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3511,
    stopColor: "#6200EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6622,
    stopColor: "#05D1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_214_10556",
    x1: 14.9912,
    y1: 1.06653,
    x2: 43.3123,
    y2: 49.7256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.75506e-7,
    stopColor: "#FF0078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0636,
    stopColor: "#E80089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1972,
    stopColor: "#AD00B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3511,
    stopColor: "#6200EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6622,
    stopColor: "#05D1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_214_10556",
    x1: 5.8788,
    y1: 6.02005,
    x2: 37.483,
    y2: 60.3198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.75506e-7,
    stopColor: "#FF0078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0636,
    stopColor: "#E80089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1972,
    stopColor: "#AD00B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3511,
    stopColor: "#6200EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6622,
    stopColor: "#05D1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_214_10556",
    x1: 30.9001,
    y1: -8.19273,
    x2: 59.2212,
    y2: 40.4663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.75506e-7,
    stopColor: "#FF0078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0636,
    stopColor: "#E80089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1972,
    stopColor: "#AD00B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3511,
    stopColor: "#6200EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6622,
    stopColor: "#05D1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo_new.6e49b2c2.svg";
export { ForwardRef as ReactComponent };